export default __webpack_public_path__ + "static/media/granville04.f56c2921.jpg";